var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")]),_vm._v(" "),_c('nav',{staticClass:"navbar fixed-bottom navbar-expand-sm navbar-dark bg-dark"},[_c('button',{staticClass:"btn btn-lg btn-secondary",on:{"click":_vm.prevAction}},[_vm._v("戻る")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e434de90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebGisDetail.vue
// module id = NRf9
// module chunks = 0